import { Component, OnInit } from '@angular/core';
import { first } from 'lodash';
import { ILoanApplication } from 'src/app/core/services/loan-application/loan-application.model';
import { TagDataService } from 'src/app/core/services/tag-data/tag-data.service';

import { ICoApplicantDetails } from '../co-app-details.model';
import { MobileApiService } from 'src/app/core/services/mobile-api';
import { LoanApplicationService } from 'src/app/core/services/loan-application/loan-application.service';
import { map } from 'rxjs';
import { QuestionTypeEnum } from '../co-app-common-questions/co-app-common-questions.component';

@Component({
	selector: 'op-co-app-invite-sent',
	templateUrl: './co-app-invite-sent.component.html',
	styleUrls: ['./co-app-invite-sent.component.scss']
})
export class CoAppInviteSentComponent implements OnInit {
	showSplashScreen: boolean;
	private _loanApp: ILoanApplication;
	coAppDetails: ICoApplicantDetails;
	questionTypeEnum = QuestionTypeEnum;

	constructor(
		private tagDataService: TagDataService,
		private mobileApiService: MobileApiService,
		private loanAppService: LoanApplicationService
	) {}

	newApplicationStartDate: Date;
	issuingOrganizationIsOportun: boolean;

	ngOnInit(): void {
		this._loanApp = this.loanAppService.getLoanApp();
		this.tagDataService.view(
			{},
			{
				event_action: 'On Page Load',
				event_category: 'co_app_invite_sent_screen_on_load',
				event_label: 'Co-Applicant Invite Sent Screen Loaded'
			}
		);

		this.mobileApiService
			.getCoApplicantDetails(this._loanApp.id)
			.pipe(map((res) => first(res)))
			.subscribe({
				next: (resp) => {
					this.coAppDetails = resp;
				}
			});
	}

	callCoApp(): void {
		if (this.coAppDetails?.phoneNumber) {
			window.location.href = `tel:+1${this.coAppDetails.phoneNumber}`;
		}
	}
}
